import { forwardRef } from "react";
import { TextField, Grid, InputAdornment } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import {
  CapitalAmount,
  setBalanceDialog,
} from "../../../../app/slices/capitalAmountSlice";
import {
  HiOutlineWallet,
  HiOutlineArrowDownTray,
  HiOutlineArrowUpTray,
} from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const NumericFormatCustom = forwardRef(function NumericFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
    />
  );
});

const CapitalAmountBalanceForm = () => {
  const _Balance = useSelector((state) => state.capitalAmount.balance);
  const _SearchBody = useSelector((state) => state.capitalAmount.searchBody);
  const loading = _Balance.loading;

  const isDeposit = _Balance.type === "deposit";

  const { control, handleSubmit } = useForm({
    defaultValues: _Balance.form,
  });

  const dispatch = useDispatch();

  const onSubmit = (data) => {
    dispatch(
      CapitalAmount.transfer(
        {
          amount: Number(data.amount),
          capital_amount_id: _Balance.capital_amount_id,
          transfer_type_id: isDeposit ? 1 : 2,
        },
        _SearchBody
      )
    );
  };

  const handleClose = () => {
    dispatch(
      setBalanceDialog({
        id: null,
        type: null,
      })
    );
  };

  return (
    <FormDialog
      open={_Balance.dialog}
      onClose={handleClose}
      icon={isDeposit ? <HiOutlineArrowDownTray /> : <HiOutlineArrowUpTray />}
      title={isDeposit ? "اضافة رصيد" : "سحب رصيد"}
      subtitle={
        isDeposit
          ? "حدد المبلغ الذي سيضاف الى رأس المال"
          : "حدد المبلغ الذي سيسحب من رأس المال"
      }
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
    >
      <SectionCard icon={<HiOutlineWallet />} title="المبلغ">
        <Grid item xs={12}>
          <Controller
            name="amount"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default CapitalAmountBalanceForm;
